<template>
  <div class="">
    <p class="title" style="cursor:pointer;" @click="$router.back(-1)">&lt;&nbsp;返回服务器列表</p>
    <el-tabs style="margin-top:0;" class="aaaa" type="border-card" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="概述" name="first">
        <div class="bg-white ofh mb30">
          <div class="">
            <el-form :inline="true" :model="filters">
              <el-row class="white-time">
                <el-col class="jkzb">时间：</el-col>
                <el-col class="white-time-div" v-bind:class="{ active:(indexa+1)==current}" v-for="(timeA,indexa) in list" @click.native="clickFun(timeA.indexa)">{{timeA.time}}</el-col>
                  <!-- <el-form-item label="" prop="daterangevalue"> -->
                          <!-- <el-date-picker style="width:300px;" v-model="form.daterangevalue" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" @change="changheDate" value-format="yyyy-MM-dd"></el-date-picker> -->
                  <!-- </el-form-item> -->
                  <el-date-picker
                      v-model="form.date1"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :editable = "false"
                      style="margin-top:3px;"
                      @change="changeDate"
                      placeholder="选择开始日期">
                  </el-date-picker>
                  <el-date-picker
                      v-model="form.date2"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :editable = "false"
                      @change="changeDate"
                      style="margin-left:10px;margin-top:3px;"
                      placeholder="选择结束日期">
                  </el-date-picker>
                    <!-- <el-input style="width:210px;" @blur="changeDate" placeholder="起始:2019-01-01 00:00:00" suffix-icon="el-icon-date" v-model="form.date1"></el-input>
                    <el-input style="width:210px;margin-left:10px;" @blur="changeDate" placeholder="结束:2019-01-02 00:00:00" suffix-icon="el-icon-date" v-model="form.date2"></el-input> -->
                  <el-col>
                    <el-col class="jkzb">监控指标：</el-col>
                     <!-- v-bind:class="{ active:(index+1)==current2}" -->
                    <el-col class="white-time-div2" v-for="(timeA,index) in list2"  :class="{'active':index_this==timeA.index}" @click.native="clickFun2(timeA.index)">{{timeA.time}}</el-col>
                  </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="card-title">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>{{titleZb}}</span>
                <span style="float: right;">周期：60s</span>
              </div>
              <div id="haderPaint">

              </div>
            </el-card>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="实例" name="second">
        <div class="bg-white ofh mb30">
          <div class="">
            <el-form :inline="true" :model="filters">

              <el-row class="white-time">
                <el-col style="height:50px;">
                  <el-col class="jkzb">实例列表：</el-col>
                  <el-select v-model="value" placeholder="请选择" @change="changeSelect">
                    <el-option
                      v-for="item in options"
                      :key="item.in_pid"
                      :label="item.node_register_ID"
                      :value="item.in_pid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="jkzb">时间：</el-col>
                <el-col class="white-time-div" v-bind:class="{ active:(index+1)==current3}" v-for="(timeA,index) in list3" :index="index" @click.native="clickFun3(timeA.index)">{{timeA.time}}</el-col>
                  <!-- <el-form-item label="" prop="daterangevalue">
                          <el-date-picker style="width:300px;" v-model="form.daterangevalue" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item> -->
                  <el-date-picker
                      v-model="form.date3"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :editable = "false"
                      style="margin-top:3px;"
                      @change="changeDate2"
                      placeholder="选择开始日期">
                  </el-date-picker>
                  <el-date-picker
                      v-model="form.date4"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :editable = "false"
                      @change="changeDate2"
                      style="margin-left:10px;margin-top:3px;"
                      placeholder="选择结束日期">
                  </el-date-picker>
                  <!-- <el-input style="width:190px;" @blur="changeDate2" placeholder="起始:2019-01-01 00:00:00" suffix-icon="el-icon-date" v-model="form.date3"></el-input>
                  <el-input style="width:190px;margin-left:10px;" @blur="changeDate2" placeholder="结束:2019-01-02 00:00:00" suffix-icon="el-icon-date" v-model="form.date4"></el-input> -->
                  <el-col>
                    <el-col class="jkzb">监控指标：</el-col>
                    <el-col class="white-time-div2" v-bind:class="{ active:(index+9)==current4}" v-for="(timeA,index) in list4" :index="index" @click.native="clickFun4(timeA.index)">{{timeA.time}}</el-col>
                  </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="card-title">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>{{titleZb2}}</span>
                <span style="float: right;">周期：60s</span>
              </div>
              <div class="" style="width:100%;height:480px;">
                <div id="haderPaint2" style="width:100%;height:480px;">

                </div>
              </div>

            </el-card>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>


<script>
  import echarts from "echarts";
  import {pathFile} from "../../assets/js/common.js";
  export default {
    name: "optionIndex",
    data() {
        return {
          index_this:'1',
          value:'',
          value1: "",
          printStr: "",
          options:[],
          current:1,
          current2:1,
          current3:1,
          current4:9,
          filters: {
            userName: "",
            //岗位列表搜索参数
            positionName: "",
            positionCode: "",
        },
          form:{
              start_date:'',
              end_date:'',
              daterangevalue:'',
              date1:'',
              date2:'',
              date3:'',
              date4:'',
          },
          indexa:'1',
          activeName:'first',
          list:[{
            time:"1小时",
            indexa:1,
          },{
            time:"6小时",
            indexa:2,
          },{
            time:"12小时",
            indexa:3,
          },{
            time:"1天",
            indexa:4,
          },{
            time:"3天",
            indexa:5,
          },{
            time:"7天",
            indexa:6,
          }],
          list2:[{
            time:"CPU使用率",
            index:1,
          },{
            time:"内存使用率",
            index:2,
          },{
            time:"平均负载",
            index:3,
          },{
            time:"磁盘IO读",
            index:4,
          },{
            time:"磁盘IO写",
            index:5,
          },{
            time:"磁盘使用率",
            index:6,
          },{
            time:"TCP连接数",
            index:7,
          },{
            time:"进程数",
            index:8,
          },{
            time:"文件打开数",
            index:14,
          }],
          list3:[{
            time:"1小时",
            index:1,
          },{
            time:"6小时",
            index:2,
          },{
            time:"12小时",
            index:3,
          },{
            time:"1天",
            index:4,
          },{
            time:"3天",
            index:5,
          },{
            time:"7天",
            index:6,
          }],
          list4:[{
            time:"CPU使用率",
            index:9,
          },{
            time:"内存使用率",
            index:10,
          },{
            time:"磁盘IO读",
            index:11,
          },{
            time:"磁盘IO写",
            index:12,
          }],
          query:this.$route.query,
          titleZb:'CPU使用率(%)',
          titleZb2:'CPU使用率(%)',
          titleText:'CPU使用率',
          titleText2:'CPU使用率',
          path:pathFile+"monitorWebSocket",
          socket:"",
      }
    },
    destroyed:function() {
      this.socket.close();
    },
    mounted(){
      this.YccxBt("0");
      this.findSl();
      this.init();
    },
    methods: {
      init: function () {
        if(typeof(WebSocket) === "undefined"){
          alert("您的浏览器不支持socket")
        }else{
          // 实例化socket
          this.socket = new WebSocket(this.path)
          // 监听socket连接
          this.socket.onopen = this.open
          // 监听socket错误信息
          this.socket.onerror = this.error
          // 监听socket消息
          this.socket.onmessage = this.getMessage
          this.socket.onclose = this.websocketclose
        }
      },
      open: function () {
        console.log("socket连接成功")
        let actions = {dataType:"1",param:this.query.sysPublicIp};
        this.socket.send(JSON.stringify(actions));
      },
      websocketclose(e){  //关闭
        console.log('断开连接',e);
      },
      error: function () {
        console.log("连接错误")
      },
      getMessage: function (msg) {
        var echartsDraw2 = JSON.parse(msg.data);
        var arr = [];
        var danwei = '%';
        for(let i=0;i<echartsDraw2.length;i++){
          if(this.current2 == "1"){
            arr.push([echartsDraw2[i].mo_time,echartsDraw2[i].mo_cpu]);
            danwei = "%";
          }else if(this.current2 == "2"){
            arr.push([echartsDraw2[i].mo_time,echartsDraw2[i].mo_ram])
            danwei = "%";
          }else if(this.current2 == "3"){
            arr.push([echartsDraw2[i].mo_time,echartsDraw2[i].mo_load])
            danwei = "";
          }else if(this.current2 == "4"){
            arr.push([echartsDraw2[i].mo_time,echartsDraw2[i].mo_ioread])
            danwei = "Bytes/s";
          }else if(this.current2 == "5"){
            arr.push([echartsDraw2[i].mo_time,echartsDraw2[i].mo_iowrite])
            danwei = "Bytes/s";
          }else if(this.current2 == "6"){
            arr.push([echartsDraw2[i].mo_time,echartsDraw2[i].mo_disk])
            danwei = "%";
          }else if(this.current2 == "7"){
            arr.push([echartsDraw2[i].mo_time,echartsDraw2[i].mo_tcp])
            danwei = "个";
          }else if(this.current2 == "8"){
            arr.push([echartsDraw2[i].mo_time,echartsDraw2[i].mo_process])
            danwei = "个";
          }else{
            arr.push([echartsDraw2[i].mo_time,echartsDraw2[i].mo_fileOpen])
            danwei = "个";
          }
        }
        var myChartCity = echarts.init(document.getElementById('haderPaint'));
        var data = arr;
        var dateList = data.map(function (item) {
            return item[0];
        });
        var valueList = data.map(function (item) {
            return item[1];
        });
        myChartCity.setOption ({
          xAxis: [{
            data: dateList
          }],
          series: [{
              data: valueList
          }]
        });
      },
      send: function (params) {
        this.socket.send(params)
      },
      close: function () {
        console.log("socket已经关闭")
      },
      //改变实例接口
      changeSelect(){
        if(this.current3 == "0"){
          this.YccxBt2("1");
        }else{
          this.YccxBt2("0");
        }
      },
      //查询实例接口
      findSl(){
        var params = {
          sysPublicIp:this.query.sysPublicIp,// 公网IP
        };
      params = this.$qs.stringify(params,{ indices: false });
      this.axios({
          method:'post',
          url:window.API_HOST+'/monitor/selectOneSystemInsInfo',
          data:params
      }).then((res)=>{
        console.log(res.data);
        if(res.data.length != 0){
          this.options = res.data;
          this.value = res.data[0].in_pid;
        }
      })
      },
      changeDate(){
        var time1 = this.form.date1;
        var time2 = this.form.date2;
        var dateSpan,
            tempDate,
            sDate1,
            sDate2;
          sDate1 = Date.parse(time1);
          sDate2 = Date.parse(time2);
          dateSpan = sDate2 - sDate1;
          dateSpan = Math.abs(dateSpan);
          var iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
          var dayS = iDays + 1;
          if(dayS > 10){
            this.$message.error("起止日期不得超过10天");
            return;
          }
          this.current = '0';
          this.YccxBt("1");
      },
      changeDate2(){
        var time1 = this.form.date3;
        var time2 = this.form.date4;
        var dateSpan,
            tempDate,
            sDate1,
            sDate2;
          sDate1 = Date.parse(time1);
          sDate2 = Date.parse(time2);
          dateSpan = sDate2 - sDate1;
          dateSpan = Math.abs(dateSpan);
          var iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
          var dayS = iDays + 1;
          if(this.form.date3.length != 19 || this.form.date4.length != 19){
            this.$message.error("起止日期格式书写有误");
            return;
          }
          if(dayS > 10){
            this.$message.error("起止日期不得超过10天");
            return;
          }
          this.current3 = '0';
          this.YccxBt2("1");
      },
      jinC(){
        this.$router.push({
            path: "/thread",
            query: {
            }
        });
      },
      handleTabClick(tab, event){
        if(this.activeName == 'first'){
          if(this.current == "0"){
            this.YccxBt("1");
          }else{
            this.YccxBt("0");
          }
        }else{
          if(this.current3 == "0"){
            this.YccxBt2("1");
          }else{
            this.YccxBt2("0");
          }

        }
      },
      clickFun(eva){
        //时间
        this.current=eva;
        if(eva != "1"){
          this.socket.close();
        }else{
          this.init()
        }
        if(this.current == "0"){
          this.YccxBt("1");
        }else{
          this.YccxBt("0");
        }
      },
      clickFun2(eva){
        //监控指标
        this.index_this = eva;
        if(this.current == "1"){
          let actions = {dataType:eva,param:this.query.sysPublicIp};
          this.socket.send(JSON.stringify(actions));
        }
        if(eva == "1"){
          this.titleZb = 'CPU使用率(%)';
          this.titleText = 'CPU使用率';
        }else if(eva == "2"){
          this.titleZb = '内存使用率(%)';
          this.titleText = '内存使用率';
        }else if(eva == "3"){
          this.titleText = '平均负载';
          this.titleZb = '平均负载';
        }else if(eva == "4"){
          this.titleZb = '磁盘IO读(Bytes/s)';
          this.titleText = '磁盘IO读';
        }else if(eva == "5"){
          this.titleZb = '磁盘IO写(Bytes/s)';
          this.titleText = '磁盘IO写';
        }else if(eva == "6"){
          this.titleZb = '磁盘使用率(%)';
          this.titleText = '磁盘使用率';
        }else if(eva == "7"){
          this.titleZb = 'TCP连接数(个)';
          this.titleText = 'TCP连接数';
        }else if(eva == "8"){
          this.titleZb = '进程数(个)';
          this.titleText = '进程数';
        }else{
          this.titleZb = '文件打开数(个)';
          this.titleText = '文件打开数';
        }
        this.current2=eva;
        if(this.current == "0"){
          this.YccxBt("1");
        }else{
          this.YccxBt("0");
        }
      },
      clickFun3(eva){
        this.current3=eva;
        if(this.current3 == "0"){
          this.YccxBt2("1");
        }else{
          this.YccxBt2("0");
        }
      },
      clickFun4(eva){
        if(eva == "9"){
          this.titleZb2 = 'CPU使用率(%)';
          this.titleText2 = 'CPU使用率';
        }else if(eva == "10"){
          this.titleZb2 = '内存使用率(%)';
          this.titleText2 = '内存使用率';
        }else if(eva == "11"){
          this.titleZb2 = '磁盘IO读(Bytes/s)';
          this.titleText2 = '磁盘IO读';
        }else if(eva == "12"){
          this.titleZb2 = '磁盘IO写(Bytes/s)';
          this.titleText2 = '磁盘IO写';
        }
        this.current4=eva;
        if(this.current3 == "0"){
          this.YccxBt2("1");
        }else{
          this.YccxBt2("0");
        }
      },
      //心电图
      YccxBt:function(e) {
        var myChartCity = echarts.init(document.getElementById('haderPaint'));
        myChartCity.showLoading();
        if(e == "0"){
          var params = {
              sysPublicIp:this.query.sysPublicIp,// 公网IP
              index:this.current2,//指标编号
              startTime:this.current,//开始时间
              endTime:''//结束时间
          };
        }else{
          var params = {
              sysPublicIp:this.query.sysPublicIp,// 公网IP
              index:this.current2,//指标编号
              startTime:this.form.date1,//开始时间
              endTime:this.form.date2//结束时间
          };
        }
        params = this.$qs.stringify(params,{ indices: false });
        var arr = [];
        var that = this;
        this.axios({
            method:'post',
            url:window.API_HOST+'/monitor/selectOneSystemMonInfo',
            data:params
        }).then((res)=>{
            var danwei = '%';
            for(let i=0;i<res.data.length;i++){
              if(this.current2 == "1"){
                arr.push([res.data[i].mo_time,res.data[i].mo_cpu]);
                danwei = "%";
              }else if(this.current2 == "2"){
                arr.push([res.data[i].mo_time,res.data[i].mo_ram])
                danwei = "%";
              }else if(this.current2 == "3"){
                arr.push([res.data[i].mo_time,res.data[i].mo_load])
                danwei = "";
              }else if(this.current2 == "4"){
                arr.push([res.data[i].mo_time,res.data[i].mo_ioread])
                danwei = "Bytes/s";
              }else if(this.current2 == "5"){
                arr.push([res.data[i].mo_time,res.data[i].mo_iowrite])
                danwei = "Bytes/s";
              }else if(this.current2 == "6"){
                arr.push([res.data[i].mo_time,res.data[i].mo_disk])
                danwei = "%";
              }else if(this.current2 == "7"){
                arr.push([res.data[i].mo_time,res.data[i].mo_tcp])
                danwei = "个";
              }else if(this.current2 == "8"){
                arr.push([res.data[i].mo_time,res.data[i].mo_process])
                danwei = "个";
              }else{
                arr.push([res.data[i].mo_time,res.data[i].mo_fileOpen])
                danwei = "个";
              }
            }

            this.tableData = res.data;
            myChartCity.hideLoading();

            var data = arr;
            var dateList = data.map(function (item) {
                return item[0];
            });
            console.log(dateList);
            var valueList = data.map(function (item) {
                return item[1];
            });
            console.log(valueList)
            var that = this;
            myChartCity.setOption ({
              // Make gradient line here
                visualMap: [{
                    show: false,
                    type: 'continuous',
                    seriesIndex: 0,
                    min: 0,
                    max: 400
                }],
                title: [{
                    left: 'center',
                    text: that.titleText
                }],
                tooltip: {
                    trigger: 'axis',
                    formatter:function(params)//数据格式
                    {
                      var relVal = params[0].name+"<br/>";
                      relVal +="<span style='color:#4D74FF;font-size:20px;'>● </span>";
                      relVal += params[0].data+ danwei;
                      return relVal;
                    }
                },
                xAxis: [{
                    data: dateList,
                    boundaryGap:false
                  }],
                yAxis: [{
                    splitLine: {show: false}
                }],
                series: [{
                    type: 'line',
                    showSymbol: false,
                    data: valueList,
                    itemStyle : {
                        normal : {
                            lineStyle:{
                                color:'#4D74FF'
                            }
                        }
                    },
                }]

            });
            setTimeout(function() {
              // window.addEventListener("resize",function(){
                  myChartCity.resize();
              // });
            },200)
            window.addEventListener("resize",function(){
                myChartCity.resize();
            });
        })

      },
      //心电图2
      YccxBt2:function(e) {
        var myChartCity = echarts.init(document.getElementById('haderPaint2'));
        myChartCity.showLoading();
        var that = this;
        var arr = [];
        if(e == "0"){
          var params = {
              sysPublicIp:this.query.sysPublicIp,// 公网IP
              pid:this.value,//实例ID
              startTime:this.current3,//开始时间
              endTime:'',//结束时间
              index:this.current4
          };
        }else{
          var params = {
              sysPublicIp:this.query.sysPublicIp,// 公网IP
              pid:this.value,//实例ID
              startTime:this.form.date3,//开始时间
              endTime:this.form.date4,//结束时间
              index:this.current4
          };
        }
        params = this.$qs.stringify(params,{ indices: false });
        var arr = [];
        this.axios({
            method:'post',
            url:window.API_HOST+'/monitor/selectOneInstanceInfo',
            data:params
        }).then((res)=>{
            // this.tableData = res.data.ivo.ivo;
            var danwei2 = '%';
            for(let i=0;i<res.data.length;i++){
              if(that.current4 == "9"){
                arr.push([res.data[i].in_time,res.data[i].in_cpu])
                danwei2 = '%';
              }else if(that.current4 == "10"){
                arr.push([res.data[i].in_time,res.data[i].in_mem])
                danwei2 = '%';
              }else if(that.current4 == "11"){
                arr.push([res.data[i].in_time,res.data[i].in_ioread])
                danwei2 = 'Bytes/s';
              }else if(that.current4 == "12"){
                arr.push([res.data[i].in_time,res.data[i].in_iowrite])
                danwei2 = 'Bytes/s';
              }
              // arr.push([res.data[i].in_time,res.data[i].in_cpu])
            }
            myChartCity.hideLoading();
            var data = arr;
            var dateList = data.map(function (item) {
                return item[0];
            });
            var valueList = data.map(function (item) {
                return item[1];
            });
            myChartCity.setOption ({
              // Make gradient line here
                visualMap: [{
                    show: false,
                    type: 'continuous',
                    seriesIndex: 0,
                    min: 0,
                    max: 400
                }],
                title: [{
                    left: 'center',
                    text: that.titleText2
                }],
                tooltip: {
                    trigger: 'axis',
                    formatter:function(params)//数据格式
                    {
                      var relVal = params[0].name+"<br/>";
                      relVal +="<span style='color:#4D74FF;font-size:20px;'>● </span>";
                      relVal += params[0].data+ danwei2;
                      return relVal;
                    }
                },
                xAxis: [{
                    data: dateList,
                    boundaryGap:false
                }],
                yAxis: [{
                    splitLine: {show: false}
                }],
                series: [{
                    type: 'line',
                    showSymbol: false,
                    data: valueList,
                    itemStyle : {
                        normal : {
                            lineStyle:{
                                color:'#4D74FF'
                            }
                        }
                    },
                }]

            });
            setTimeout(function() {
              // window.addEventListener("resize",function(){
                  myChartCity.resize();
              // });
            },200)
            window.addEventListener("resize",function(){
                myChartCity.resize();
            });
        })

      }
    },

  };
</script>
<style lang="scss" scoped>
@import "../../assets/css/Border.css";
.title{
   margin-bottom: 5px;
   cursor: pointer;
   color: #1385F9;
}
.card-title{
  margin-top: 20px;
}
.el-card__header{
  padding: 9px 20px !important;
}
#haderPaint,#haderPaint2{
  height: 480px;
}
#haderPaint2>div{
  width: 100% !important;
}
  .jkzb{
    display: inline-block;
    width: 80px;
    vertical-align: middle;
    height: 53px;
    line-height: 35px;
    margin-left: 10px;
  }
  .white-time{
    margin-bottom: -12px;
  }
  .white-time .white-time-div{
    width: 82px;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
    margin: 3px 10px;
    margin-left: 0;
}
.white-time .white-time-div2{
  width: 111px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: .1s;
  transition: .1s;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  margin: 3px 10px;
  margin-left: 0;
}
.white-time .white-time-div2:hover{
    border: 1px solid #C6E2FF;
    background: #ECF5FF;
    color: #409EFF;
}
.white-time .white-time-div:hover{
    border: 1px solid #C6E2FF;
    background: #ECF5FF;
    color: #409EFF;
}
.active{
  border: 1px solid #C6E2FF !important;
  background: #ECF5FF !important;
  color: #409EFF !important;
}
</style>
